var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45488 5.95494L14 4.34717L12.6198 9.95327L10.898 8.30037L8.12069 11.1934C8.02641 11.2916 7.89615 11.3472 7.76 11.3472C7.62385 11.3472 7.49359 11.2916 7.39931 11.1934L5.36 9.06916L2.36069 12.1934C2.16946 12.3926 1.85294 12.3991 1.65373 12.2079C1.45453 12.0166 1.44807 11.7001 1.63931 11.5009L4.99931 8.0009C5.09359 7.90269 5.22385 7.84717 5.36 7.84717C5.49615 7.84717 5.62641 7.90269 5.72069 8.0009L7.76 10.1252L10.1766 7.60784L8.45488 5.95494Z",
    fill: "#29CC39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSet);
export default __webpack_public_path__ + "static/media/IconSet.da3fa15634348b7d43e89d6bb53e8695.svg";
export { ForwardRef as ReactComponent };